<template>
    <common-page>
        <div class="bg-cover w-100 d-flex flex-column">
            <div class="w-100 h-auto position-relative">
                <b-img :src="require('../../../../../assets/images/ehs/ehs-1.png')" fluid class="w-100"></b-img>
                <div class="title-cover"></div>
            </div>
            <h2 class="title">人人都是安全员</h2>
            <div class="card d-flex flex-column m-2 p-3">
                <h4 class="card-label">
                    隐患记录
                </h4>
                <div class="d-flex flex-row">
                    <div class="col-6 d-flex flex-column" @click="toView(1)">
                        <b-spinner v-if="waitRectify==null" class="m-auto" variant="secondary" small></b-spinner>
                        <h3 v-else class="m-auto">{{ waitRectify }}</h3>
                        <h4 class="text-danger label-cover">待整改</h4>
                    </div>
                    <div class="col-6 d-flex flex-column" @click="toView(2)">
                        <b-spinner v-if="rectified==null" class="m-auto" variant="secondary" small></b-spinner>
                        <h3 v-else class="m-auto">{{ rectified }}</h3>
                        <h4 class="text-success label-cover">已整改</h4>
                    </div>
                </div>
            </div>
            <div class="card d-flex flex-column ml-2 mr-2 mb-2 p-3">
                <h4 class="card-label">
                    操作入口
                </h4>
                <div class="d-flex flex-row">
                    <div class="col-4 d-flex flex-column" @click="toNew">
                        <div class="icon-cover" style="background-color: #e9a735">
                            <i class="fa-solid fa-triangle-exclamation"></i>
                        </div>
                        <div>码上报</div>
                    </div>
                    <div class="col-4 d-flex flex-column" @click="toView(0)">
                        <div class="icon-cover" style="background-color: #1d3277">
                            <i class="fa-solid fa-wrench"></i>
                        </div>
                        <div>码上改</div>
                    </div>
                    <div class="col-4 d-flex flex-column" @click="toView(3)">
                        <div class="icon-cover" style="background-color: #65e1b8">
                            <i class="fa-solid fa-check-to-slot"></i>
                        </div>
                        <div>审核</div>
                    </div>
                </div>
            </div>
        </div>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";

export default {
    name: "HazardHome",
    components: {CommonPage},
    data() {
        return {
            waitRectify: null,
            rectified: null,
        }
    },
    mounted() {
        this.getCount();
    },
    methods: {
        toNew() {
            this.$router.push("/hazard/edit");
        },
        toView(tag) {
            this.$router.push({
                path: "/hazard/list",
                query: {
                    tag: tag
                }
            })
        },
        getCount() {
            this.$query({
                key: 'hazard_list',
                where: {processStatusLte: 1},
                count: true
            }).then(res => this.waitRectify = res.data);
            this.$query({
                key: 'hazard_list',
                where: {processStatusGte: 2},
                count: true
            }).then(res => this.rectified = res.data);
        },
    }
}
</script>

<style scoped>
.bg-cover {
    background-color: #521772;
    overflow-y: auto;
}

.title-cover {
    width: 100%;
    height: 70px;
    font-weight: bold;
    position: absolute;
    bottom: -1px;
    background-image: linear-gradient(rgba(82, 23, 114, 0), #521772)
}

.title {
    margin: .25rem auto;
    color: white;
}

h3 {
    font-size: 1.5rem;
}

h4 {
    font-size: .9rem;
}

.card-label {
    margin-bottom: .8rem;
}

.label-cover {
    margin: .3rem auto auto auto;
}

.icon-cover {
    width: 55px;
    height: 55px;
    margin: auto;
    display: flex;
    border-radius: 5px;
}

.icon-cover i {
    font-size: 1.8rem;
    color: white;
    margin: auto;
}

.icon-cover ~ div {
    margin: .4rem auto auto auto;
}
</style>
